import { Component, Inject, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, NgClass } from '@angular/common';
import { CommonBindingDataService } from '../../../../../../shared/services/common-binding-data.service';

@Component({
  selector: 'app-quantity-product-table',
  standalone: true,
  imports: [TableModule, TranslateModule, NgClass, CommonModule],
  templateUrl: './quantity-product-table.component.html',
  styleUrl: './quantity-product-table.component.scss'
})
export class QuantityProductTableComponent {
  @Input() orderSummary: any[];
  @Input() products: any[];
  @Input() isReturn: boolean = false;
  showConfirmDateDialog: boolean = false;
  @Inject(CommonBindingDataService) public cs: CommonBindingDataService;

  onCancelDateDialog() {
    this.showConfirmDateDialog = false;
  }
}
